import { useState } from "react";
import popupStyles from "./translationPopup.module.css"
import { IPopupWithoutProps } from "../../../types/types";
import CloseButton from "../../closeButton/closeButton.module";
import { tWithKeyAttr as t } from "../../../i18nHelper";

function TranslationPopup({
  onClose,
  onSave,
  onTranslate,
  onSaveAll,
  text,
  translationKey
}: IPopupWithoutProps & {
  text: string,
  translationKey: string,
  onSave: (key: string, value: string) => void,
  onSaveAll: (key: string) => void,
  onTranslate: (text: string) => void
}) {

  const [inputValue, setInputValue] = useState(text || "");

  async function sendToApiTranslation(text: string) {
    await onTranslate(text);
    onClose();

  }

  return (
    <>
      <div className={popupStyles.overlay} />
      <article className={popupStyles.popup}>
        <CloseButton onClick={onClose} />
        <h2 className={popupStyles.popup__title}>
          {t("TEXT_EDITING")}
        </h2>
        <textarea
          className={popupStyles.popup__text}
          defaultValue={text}
          onChange={(e) => setInputValue(e.target.value)}
        />
        <div className={`${popupStyles.two}`}>
          <button
            type="button"
            className={`hover ${popupStyles.popup__nextBtn}`}
            onClick={() => onSave(translationKey, inputValue)}
          >
            {t("UPDATE_CURRENT_LANGUAGE_ONLY")}
          </button>

          <button
            type="button"
            className={`hover ${popupStyles.popup__nextBtn}`}
            onClick={(e) => { e.preventDefault(); sendToApiTranslation(inputValue) }}
          >
            {t("TRANSLATE_TO_ALL_LANGUAGE")}
          </button>
        </div>

      </article>
    </>
  );
}

export default TranslationPopup;
